<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-center txt-primario">Búsqueda individual</h5>
  </div>
  <div class="col-md-auto col-2">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <mat-card-content class="py-0">
    <form [formGroup]="formBusquedaSiniestro">
      <div
        class="row mx-md-0 my-2 justify-content-md-center justify-content-sm-center justify-content-center mx-auto overflow-auto">
        <div class="col-md-12 col-auto">
          <mat-form-field class="inputFormulario">
            <mat-label>Sucursal</mat-label>
            <input matInput type="text" formControlName="sucursal" placeholder="Sucursal" UpperCase minlength="3" maxlength="3">
            @if (formBusquedaSiniestro.get('sucursal').hasError('required')) {
              <mat-error>
                El campo es requerido
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-12 col-auto">
          <mat-form-field class="inputFormulario">
            <mat-label>Año</mat-label>
            <input matInput type="text" formControlName="anio" placeholder="Año" [OnlyNumber]="true" maxlength="4" minlength="4">
            @if (formBusquedaSiniestro.get('anio').hasError('required')) {
              <mat-error>
                El campo es requerido
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-12 col-auto">
          <mat-form-field class="inputFormulario">
            <mat-label>No. Siniestro:</mat-label>
            <input matInput type="text" formControlName="consecutivo" placeholder="No. Siniestro" [OnlyNumber]="true">
            @if (formBusquedaSiniestro.get('consecutivo').hasError('required')) {
              <mat-error>
                El campo es requerido
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
<mat-card-actions class="row mx-0 justify-content-end">
  <div class="col-md-auto col-auto">
    <button type="submit" color="primary" class="mx-1 my-1" mat-raised-button (click)="closeDialog('Aceptar')"
      [disabled]="!formBusquedaSiniestro.valid">
      Aceptar
    </button>
  </div>
</mat-card-actions>